import { useCentrixApi } from "core/hooks/useCentrixApi";

export function useWeatherForecast(days: number = 7) {
  return useCentrixApi({
    path: "/api/app/weather/forecast-current-user-locations",
    parameters: { query: { days } },
  });
}
